import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const HolaVidaLogo: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      // width="200"
      // height="99"
      viewBox="0 0 200 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="20" width="160" height="99" rx="10" fill="white" />
      <g clipPath="url(#clip0_826_5019)">
        <path
          d="M36.588 62.6895V71.1348H28.3016V62.6895H24V83.63H28.3016V74.8435H36.588V83.63H40.8896V62.6895H36.588Z"
          fill="#00B5B8"
        />
        <path
          d="M53.3533 67.5625C48.2978 67.5625 44.1523 71.2753 44.1523 75.7809C44.1523 80.2866 48.2978 83.9974 53.3827 83.9974C58.4677 83.9974 62.6448 80.3193 62.6448 75.8934C62.6448 71.2181 58.5945 67.5625 53.3533 67.5625ZM53.4145 80.54C50.589 80.54 48.3612 78.4149 48.3612 75.7238C48.3612 73.145 50.6523 71.024 53.3827 71.024C56.1788 71.024 58.4383 73.1777 58.4383 75.785C58.4383 78.3924 56.1788 80.54 53.4145 80.54Z"
          fill="#00B5B8"
        />
        <path
          d="M64.9922 62.6895V83.63H69.1693V62.6895H64.9922Z"
          fill="#00B5B8"
        />
        <path
          d="M86.3201 67.9324V70.0288C84.8757 68.3001 83.1505 67.5625 80.6375 67.5625C75.4891 67.5625 71.7852 71.0485 71.7852 75.8361C71.7852 80.5686 75.4574 83.9974 80.5446 83.9974C82.992 83.9974 84.6561 83.2904 86.3201 81.5903V83.6337H90.1509V67.9364L86.3201 67.9324ZM81.1401 80.54C78.095 80.54 75.9917 78.6703 75.9917 75.9219C75.9917 73.0612 78.095 71.0178 81.0767 71.0178C84.0584 71.0178 86.1956 73.0305 86.1956 75.8913C86.1956 78.5007 84.312 80.54 81.1401 80.54Z"
          fill="#00B5B8"
        />
        <path
          d="M108.831 62.6896L102.575 78.6116L96.3288 62.6875H91.8008L100.843 83.6281H104.359L113.338 62.6875L108.831 62.6896Z"
          fill="#00B5B8"
        />
        <path
          d="M115.266 61.8965V65.6645H119.441V61.8965H115.266ZM115.234 67.9326V83.6299H119.409V67.9326H115.234Z"
          fill="#00B5B8"
        />
        <path
          d="M136.145 62.6895V69.3202C134.92 68.0941 132.912 67.3647 130.712 67.3647C125.846 67.3647 122.016 71.0427 122.016 75.7527C122.016 80.3994 125.815 83.9978 130.743 83.9978C133.098 83.9978 134.819 83.2908 136.489 81.5907V83.6341H140.32V62.6935L136.145 62.6895ZM131.404 80.5404C128.486 80.5404 126.224 78.3602 126.224 75.5832C126.224 72.9268 128.454 70.8221 131.312 70.8221C134.23 70.8221 136.46 72.9472 136.46 75.6956C136.46 78.4439 134.23 80.5404 131.404 80.5404Z"
          fill="#00B5B8"
        />
        <path
          d="M157.272 67.9324V70.0288C155.827 68.3001 154.102 67.5625 151.589 67.5625C146.441 67.5625 142.734 71.0485 142.734 75.8361C142.734 80.5686 146.409 83.9974 151.494 83.9974C153.944 83.9974 155.608 83.2904 157.272 81.5903V83.6337H161.102V67.9364L157.272 67.9324ZM152.092 80.54C149.046 80.54 146.943 78.6703 146.943 75.9219C146.943 73.0612 149.046 71.0178 152.028 71.0178C155.01 71.0178 157.145 73.0305 157.145 75.8913C157.136 78.5007 155.261 80.54 152.092 80.54Z"
          fill="#00B5B8"
        />
        <path
          d="M153.779 45.1249L148.866 45.8626C148.823 45.6296 148.775 45.3967 148.721 45.1678C146.645 36.2219 136.833 30.0079 126.898 31.4996C117.638 32.8871 110.864 40.5252 110.93 48.8684C110.935 49.7585 111.019 50.6467 111.181 51.5248L106.357 52.2481L106.259 52.2113C105.945 50.4848 105.869 48.7298 106.033 46.9864C106.939 37.2722 115.132 28.7165 126.079 27.0716C132.327 26.1337 138.678 27.5171 143.964 30.9541C148.017 33.572 151.082 37.2495 152.744 41.4897C153.205 42.6723 153.551 43.8886 153.779 45.1249Z"
          fill="#00B5B8"
        />
        <path
          d="M124.753 5.9951L119.84 6.73242L123.199 24.9665L128.112 24.2292L124.753 5.9951Z"
          fill="#00B5B8"
        />
        <path
          d="M113.416 17.4779L109.078 19.6875L114.599 28.5157L118.936 26.3061L113.416 17.4779Z"
          fill="#00B5B8"
        />
        <path
          d="M95.5552 19.0417L92.3164 22.457L107.876 34.4765L111.115 31.0612L95.5552 19.0417Z"
          fill="#00B5B8"
        />
        <path
          d="M95.05 34.4159L93.3008 38.625L103.817 42.1851L105.566 37.976L95.05 34.4159Z"
          fill="#00B5B8"
        />
        <path
          d="M158.03 25.0855L149.355 31.5254L152.52 34.9972L161.194 28.5573L158.03 25.0855Z"
          fill="#00B5B8"
        />
        <path
          d="M152.112 10.6495L141.699 26.5664L145.988 28.8521L156.401 12.9352L152.112 10.6495Z"
          fill="#00B5B8"
        />
        <path
          d="M134.64 14.347L132.582 24.3125L137.479 25.1364L139.537 15.1709L134.64 14.347Z"
          fill="#00B5B8"
        />
        <path
          d="M164 33.6939C163.442 35.0003 162.785 36.2708 162.035 37.4966C160.892 39.4019 159.586 41.224 158.13 42.9462C156.767 44.5633 155.266 46.0814 153.64 47.4867C152.509 48.463 151.312 49.3767 150.059 50.2227C143.737 54.4893 136.411 56.6696 128.281 56.7023C121.489 56.7268 114.144 55.2311 106.358 52.2395L106.261 52.2027C102.385 50.6922 98.6241 48.9502 95.0044 46.9881C94.8301 46.8962 94.6512 46.798 94.4724 46.7C93.8588 46.3689 93.2362 46.0236 92.6295 45.6783C91.751 45.1817 90.8794 44.7035 90.0417 44.2581C82.6655 40.3409 75.6561 37.7704 69.2127 36.6179C56.7448 34.3886 46.2443 37.3413 38.0033 45.3922C31.7546 51.4978 29.2234 58.2879 29.1985 58.3574L24.2539 56.8842C24.3694 56.5674 27.1722 49.0478 34.1771 42.2045C40.7427 35.7863 52.33 28.8101 70.2248 32.006C77.2432 33.2626 84.8073 36.0212 92.6883 40.2081C93.5668 40.674 94.4837 41.1767 95.4052 41.6998C95.9847 42.0267 96.5779 42.3557 97.1688 42.6766L97.6714 42.9483C100.539 44.4863 103.331 45.8295 106.048 46.9778C107.709 47.6808 109.34 48.3094 110.943 48.8639C125.188 53.7986 137.26 53.0017 146.952 46.4588C147.556 46.0501 148.15 45.6197 148.734 45.1674C149.187 44.8201 149.624 44.4584 150.056 44.0865C151.008 43.2655 151.91 42.3985 152.757 41.4893C153.184 41.0371 153.599 40.5725 154.002 40.0957C155.293 38.5682 156.451 36.9525 157.464 35.2631C158.09 34.2394 158.642 33.18 159.117 32.0918L164 33.6939Z"
          fill="#FF8175"
        />
      </g>
      <defs>
        <clipPath id="clip0_826_5019">
          <rect
            width="140"
            height="78"
            fill="white"
            transform="translate(24 6)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default HolaVidaLogo;
